/* Phone validation utility — used across all forms in the app.
 *
 * Israeli phone numbers must:
 *   • Start with `0`
 *   • Contain exactly 10 digits total
 *
 * Spaces, dashes, parens, and plus signs are stripped before validation.
 */

const BLOCKED_PHONES = ['0500000000', '0512345678'];

const cleanPhone = (phone) => (phone || '').replace(/[\s\-+()]/g, '');

export const isBlockedPhone = (phone) => BLOCKED_PHONES.includes(cleanPhone(phone));

export const isValidIsraeliPhone = (phone) => /^0\d{9}$/.test(cleanPhone(phone));

export const BLOCKED_PHONE_MSG = 'מספר הטלפון שהוזן אינו תקין. נא להזין מספר אמיתי.';
export const INVALID_PHONE_MSG = 'מספר טלפון לא תקין. חייב להתחיל ב-0 ולהכיל 10 ספרות.';

/** Returns null if phone is valid; otherwise returns a Hebrew error message. */
export const validatePhone = (phone) => {
  if (!isValidIsraeliPhone(phone)) return INVALID_PHONE_MSG;
  if (isBlockedPhone(phone)) return BLOCKED_PHONE_MSG;
  return null;
};

/**
 * Auto-format an Israeli phone number as the user types.
 * Strips all non-digit characters, caps at 10 digits, and inserts a single
 * dash after the 3-digit prefix (e.g. `0501234567` -> `050-1234567`).
 * Returns the original raw string if it contains fewer than 3 digits so
 * the user can still freely type/delete the prefix.
 */
export const formatPhoneInput = (raw) => {
  const digits = (raw || '').replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  return `${digits.slice(0, 3)}-${digits.slice(3)}`;
};
